/**
 * AGROMX Frontend - Router
 * Sistema de rutas SPA con History API
 */

class Router {
  constructor() {
    this.routes = {};
    this.currentRoute = null;
    this.contentElement = null;
    
    // Listener para navegación
    window.addEventListener('popstate', () => this.handleRoute());
  }

  /**
   * Registrar ruta
   */
  register(path, view) {
    this.routes[path] = view;
  }

  /**
   * Configurar elemento de contenido
   */
  setContentElement(element) {
    this.contentElement = element;
  }

  /**
   * Navegar a una ruta
   */
  navigate(path) {
    window.history.pushState({}, '', path);
    // Cerrar sidebar en móvil al navegar
    const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('sidebarOverlay');
    if (sidebar) sidebar.classList.remove('open');
    if (overlay) overlay.classList.remove('active');
    this.handleRoute();
  }

  /**
   * Manejar ruta actual
   */
  async handleRoute() {
    const path = window.location.pathname;

    // Buscar ruta exacta primero
    let route = this.routes[path];
    let params = {};

    // Si no se encuentra ruta exacta, buscar ruta con parámetros
    // Priorizar rutas sin parámetros sobre rutas con parámetros
    if (!route) {
      const routeKeys = Object.keys(this.routes);
      // Ordenar rutas: primero las que no tienen parámetros, luego las que sí
      const sortedRoutes = routeKeys.sort((a, b) => {
        const aHasParams = a.includes(':');
        const bHasParams = b.includes(':');
        if (aHasParams && !bHasParams) return 1;
        if (!aHasParams && bHasParams) return -1;
        return 0;
      });

      for (const routePath of sortedRoutes) {
        const matchedParams = this.matchRoute(routePath, path);
        if (matchedParams) {
          route = this.routes[routePath];
          params = matchedParams;
          break;
        }
      }
    }

    // Asignar params a la ruta
    if (route) {
      route.params = params;
    }

    // Si no se encuentra ninguna ruta, ir a 404 o home
    if (!route) {
      route = this.routes['/'] || { render: () => '<h1>404 - Página no encontrada</h1>' };
    }

    this.currentRoute = route;

    // Resolver lazy view si es función
    if (typeof route === 'function') {
      route = await route();
      route.params = params;
      this.currentRoute = route;
    }

    // Renderizar vista
    if (this.contentElement) {
      try {
        const html = await route.render(route.params || {});
        this.contentElement.innerHTML = html;

        // Ejecutar afterRender si existe
        if (route.afterRender) {
          await route.afterRender(route.params || {});
        }
      } catch (error) {
        console.error('Error al renderizar ruta:', error);
        this.contentElement.innerHTML = '<h1>Error al cargar la página</h1>';
      }
    }
  }

  /**
   * Comparar ruta con patrón y extraer parámetros
   */
  matchRoute(pattern, path) {
    const patternParts = pattern.split('/');
    const pathParts = path.split('/');

    if (patternParts.length !== pathParts.length) {
      return null;
    }

    const params = {};
    
    for (let i = 0; i < patternParts.length; i++) {
      if (patternParts[i].startsWith(':')) {
        const paramName = patternParts[i].slice(1);
        params[paramName] = pathParts[i];
      } else if (patternParts[i] !== pathParts[i]) {
        return null;
      }
    }

    return params;
  }

  /**
   * Actualizar enlaces del DOM
   */
  setupLinks() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-link]');
      if (link) {
        e.preventDefault();
        this.navigate(link.getAttribute('href'));
      }
    });
  }
}

export default new Router();
